<template>
  <div>
    <v-autocomplete
      :items="employees"
      prepend-icon="mdi-account"
      multiple
      v-model="selected"
      :search-input.sync="local_search"
      chips 
      :clearable="!readonly"
      hide-details
      hide-selected
      item-text="name"
      item-value="user_id"
      label="Responsável"
      cache-items
      persistent-hint
      :readonly="readonly"
      color="secondary" 
      :rules="required_multiple"
    >
      <template v-slot:no-data>
        <v-list-item>
          <v-list-item-title>Atribua responsáveis pela aprovação</v-list-item-title>
        </v-list-item>
      </template>
      <template v-slot:selection="{ attr, on, item, selected }">
        <v-chip
          v-bind="attr"
          :input-value="selected"
          color="secondary"
          class="white--text"
          v-on="on"
        >
          <v-icon left>mdi-account-circle</v-icon>
          <span v-text="item.email? item.email : item.name"></span>
        </v-chip>
      </template>
      <template v-slot:item="{ item }">
        <v-list-item-avatar size="20" color="indigo" class="headline font-weight-light white--text">
          <v-icon small dark>mdi-account</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title v-text="item.name"></v-list-item-title>
          <v-list-item-subtitle v-if="item.email" v-text="item.email"></v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import table_pagination from '../../mixins/table_pagination';
import Api from '@/api';
import { mapState } from 'vuex';
import validations from '@/mixins/validations';

  export default {
    name: "SelectUser",
    mixins: [
      table_pagination
    ],
    props: {
      readonly: {
        type: Boolean,
        default: false
      },
      user_ids: {
        type: Array,
        default: () => []
      }
    },
    mixins: [
      validations
    ],
    data() {
      return {
        employees: [],
        type_timer: null,
        selected: [],
        local_search: null
      }
    },
    mounted () {
      console.log("ids => ", this.user_ids)
      if (this.user_ids && this.user_ids.length) {
        this.setSelected();
        this.getEmployees(this.user_ids);
      }
    },
    methods: {
      setSelected() {
        this.selected = [...this.user_ids];
      },
      setTypeTimer() {
        clearTimeout(this.type_timer);
        this.type_timer = setTimeout(() => {
          this.search = this.local_search;
          this.getEmployees();  
        }, 500);
      },
      async getEmployees(user_ids) {
        this.loading_employees = true;

        let filter = {
          query: this.search,
          solution_id: this.solution_id,
          company_id: this.one_user.company.data.attributes.id,
          user_ids: user_ids ? user_ids : null
        };

        try {
          const response = await Api.Employee.index(filter);
          console.log("response => ", response);
          const data = response.data.data;

          console.log({data});

          this.employees = data.map((emp) => emp.attributes);
        } catch (error) {
          console.log(error);
        } finally {
          this.loading_employees = false;
        }
      },
    },
    computed: {
      ...mapState({
        solution_id: state => state.Solution.solutionID,
        one_user: state => state.User.oneUser
      })
    },
    watch: {
      selected(newValue, oldValue) {
        if (newValue) {
          this.$emit('selected', this.selected);
        }
      },
      local_search(newValue, oldValue) {
        if (newValue) {
          this.setTypeTimer();
        }
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>